export default "__VITE_ASSET__80b7cae7__"